import { render } from "./Taiwan.vue?vue&type=template&id=e09c7f5e"
import script from "./Taiwan.vue?vue&type=script&lang=js"
export * from "./Taiwan.vue?vue&type=script&lang=js"

import "./Taiwan.vue?vue&type=style&index=0&id=e09c7f5e&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__